<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col v-if="$can('read', 'open-banking')" xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="user_full_name">
                                                {{ $t('label.user_full_name') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="user_full_name"
                                                    dir="rtl"
                                                    name="user_full_name"
                                                    id="user_full_name"
                                                    v-model="query.user_full_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="title">
                                                {{ $t('application.title') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="title"
                                                    dir="ltr"
                                                    name="title"
                                                    id="title"
                                                    v-model="query.title"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('application.application_status') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="status"
                                                    class="form-control"
                                                    name="status"
                                                    v-model="query.status"
                                            >
                                                <option
                                                        v-bind:key="index"
                                                        v-for="(application_status, index) in application_statuses"
                                                        v-bind:value="application_status.value"
                                                        :selected="query.application_status === application_status.value"
                                                >
                                                    {{ application_status.name }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('open_banking.service') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="service_type"
                                                    class="form-control"
                                                    name="service_type"
                                                    v-model="query.service_type"
                                            >
                                                <option value=""></option>
                                                <option
                                                        v-for="service in services"
                                                        v-bind:key="service"
                                                        v-bind:value="service"
                                                        :selected="query.service_type === service"
                                                >
                                                    {{$t('application.services.'+service)}}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('application.app_service_status') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="service_status"
                                                    class="form-control"
                                                    name="service_status"
                                                    v-model="query.service_status"
                                            >
                                                <option value=""></option>
                                                <option
                                                        v-for="application_status in applicationServiceStatus"
                                                        v-bind:key="application_status"
                                                        v-bind:value="application_status"
                                                        :selected="query.service_status === application_status"
                                                >
                                                    {{ applicationServiceStatusStr.get(application_status) }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="$can('read', 'open-banking')"  xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('application.application_type') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="application_type"
                                                    class="form-control"
                                                    name="application_type"
                                                    v-model="query.application_type"
                                            >
                                                <option value=""></option>
                                                <option
                                                        v-for="type in userTypes"
                                                        v-bind:key="type"
                                                        v-bind:value="type"
                                                        :selected="query.application_type === type"
                                                >
                                                    {{ userTypesStr.get(type) }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="$can('read', 'open-banking')"  xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('label.wage_type') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="wage_type"
                                                    class="form-control"
                                                    name="wage_type"
                                                    v-model="query.wage_type"
                                            >
                                                <option value=""></option>
                                                <option
                                                    v-for="type in applicationWageType"
                                                    v-bind:key="type"
                                                    v-bind:value="type"
                                                    :selected="query.wage_type === type"
                                                >
                                                    {{ applicationWageTypeStr.get(type) }}
                                                </option>

                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import {applicationStatusStr, applicationStatus} from '@/constants/applicationStatus'
import {applicationServiceStatus,applicationServiceStatusStr,services,
    applicationWageType,applicationWageTypeStr} from '@/constants/openBanking'
import {userTypes,userTypesStr} from '@/constants/userTypes'
import $ from "jquery";
import {i18n} from '@/plugins/i18n'

export default {
    props: {
        action: {
            default: function (e, query) {
            },
            required: true,
        }
    },
    mounted() {
        this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    },
    data() {
        return {
            application_statuses: [
                {
                    name: '',
                    value: ''
                },
                {
                    name: applicationStatusStr.ACTIVE,
                    value: applicationStatus.ACTIVE
                },
                {
                    name: applicationStatusStr.PENDING,
                    value: applicationStatus.PENDING
                },
                {
                    name: applicationStatusStr.DISABLE,
                    value: applicationStatus.DISABLE
                },
                {
                    name: applicationStatusStr.REJECTED,
                    value: applicationStatus.REJECTED
                },
            ],
            query: {
                status: null
            },
            applicationServiceStatus,
            applicationServiceStatusStr,
            userTypes,
            services,
            userTypesStr,
            applicationWageType,
            applicationWageTypeStr
        }
    }
}
</script>

<style>

</style>